import React from 'react'
import PropTypes from 'prop-types'

// Styles
import { footerStyle } from './styles'

// Components
import Paginator from './Paginator'

// Exports
export const TableFooter = (props) => (
  <div data-test='TableFooter' style={footerStyle}>
    <Paginator {...props} />
  </div>
)

TableFooter.propTypes = {
  children: PropTypes.node,
}

export default TableFooter
